
import { defineComponent, ref, inject, watch, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "ProfessionalSummary",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const formData = ref<Record<string, unknown>>(props.formDataTemp);
    watch(() => props.formDataTemp, (value) => {
      formData.value = { ...value };
      telephone.value = (() => {
        if (telephone.value) {
          formData.value["telephone"] = telephone.value;
          return telephone.value;
        }
        return value?.telephone ?? "";
      })();
      website.value = (() => {
        if (website.value) {
          formData.value["website"] = website.value;
          return website.value;
        }
        return value?.website ?? "";
      })();
      currency.value = (() => {
        if (currency.value) {
          formData.value["currencyCode"] = currency.value;
          return currency.value;
        }
        return value?.currencyCode ?? "";
      })();
      geoFocus.value = (() => {
        if (geoFocus.value) {
          formData.value["geoFocusCountryCode"] = geoFocus.value;
          return geoFocus.value;
        }
        return value?.geoFocusCountryCode ?? "";
      })();
    });
    const telephone = ref<string>("");
    const website = ref<string>("");
    const currency = ref<string>("");
    const geoFocus = ref<string>("");
    const limitInput = (event) => {
      if (event.target.value.length > 11) {
        event.preventDefault();
      }
      if (event.charCode < 48 || event.charCode > 57) {
        event.preventDefault();
      }
    };
    const formatTelephone = (e) => {
      if (e.target.value.charCodeAt(0) != 48 && e.target.value) {
        telephone.value = "0" + telephone.value;
      }
      if ((e.target.value.length == 6)
      ) {
        telephone.value =
          (telephone.value as string).substr(0, 5) +
          " " +
          (telephone.value as string).substr(5);
      }
      if(!(e?.target?.value ?? "")?.includes(" ") && (e.target.value.length == 11)){
        telephone.value =
          (telephone.value as string).substr(0, 5) +
          " " +
          (telephone.value as string).substr(5);
      }
    };
    const fieldChanged = async (event) => {
      formData.value[event.target.name] = event.target.value;
      emit("form-data", formData.value);
    };
    const createDraft = async () => {
      // try {
      //   const res = await store.dispatch(Actions.CREATE_BUSINESS_DRAFT, {
      //     business: JSON.stringify(formData.value),
      //   });
      //   if (res !== true) throw new Error("error in API");
      // } catch (err) {
      //   console.log({ err });
      // }
    };
    return {
      createDraft,
      formData,
      fieldChanged,
      limitInput,
      telephone,
      formatTelephone,
      website,
      geoFocus,
      currency,
    };
  },
});
